import React from "react";
import { Offcanvas } from "olive-react-myoneui";

export default function OffcanvasWrapper({
  show,
  onClose,
  title,
  children,
  placement = "end",
  className = "",
  footer,
}) {
  return (
    <Offcanvas
      className={`pb-0 ${className}`}
      show={show}
      onHide={onClose}
      placement={placement}
    >
      <Offcanvas.Header closeButton icon="close" className="pb-0">
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>{children}</Offcanvas.Body>

      {footer && <Offcanvas.Footer>{footer}</Offcanvas.Footer>}
    </Offcanvas>
  );
}
